var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParameters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16.0 16.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "parameters_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parameters_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L4,11 L0,11 L0,0 L4,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parameters_i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L4,7 L0,7 L0,0 L4,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "parameters_i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L4,16 L0,16 L0,0 L4,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.0 -1184.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#parameters_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.999999999998636 1180.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.0 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 5.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#parameters_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4,0 4,11 0,11 0,0",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.0 9.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#parameters_i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4,0 4,7 0,7 0,0",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#parameters_i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4,0 4,16 0,16 0,0",
    stroke: "none"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameters);
export default __webpack_public_path__ + "static/media/parameters.e61a2f49c29919a88e0e4f9a927570d9.svg";
export { ForwardRef as ReactComponent };